module.exports = __webpack_public_path__ + "img/1.eb2a8861.jpg";